<template>
<v-dialog
    v-model="dialog"
    max-width="920"
    v-if="value != null"
>
    <v-card>
        <v-card-title>{{label}}</v-card-title>

        <v-card-text>

            <div
                style="display: flex; gap: 25px; width: 100%;"
            >
                <div
                    style="width: 50%"
                >
                    <m-edit-css-property-ctrl
                        :property_name="value.name"
                        :value="default_value"
                        is_default
                    />
                </div>
                <div
                     style="width: 50%"
                >
                    <m-edit-css-property-ctrl
                        :property_name="value.name"
                        v-model="value.value.raw_value"
                    />
                </div>
            </div>

            <div>
                <a
                    v-on:click="onClickFonts"
                    v-if="(label ?? '').toLowerCase().includes('font-family')"
                >
                    Upload / Manage Your Organization's Fonts...
                </a>
            </div>

        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                v-on:click="onClickReset"
                v-if="has_default_value"
            >
                Reset to Default Value
            </v-btn>

            <v-btn
                text
                v-on:click="onClickDelete"
                v-else
            >
                Delete...
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>
        

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            label : null,
            value: null,
            property_name: null,
        }
    },

    methods: {
        showDialog(params)
        {
            this.value = _.cloneDeep(params.value);
            this.label = _.cloneDeep(params.label);

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('modify', {
                'op': 'set-property',
                'property_name': this.value.name,
                'value': this.value.value.raw_value
            });
        },

        onCancel()
        {
            this.dialog = false;
        },
        
        onClickReset()
        {
            this.value.value = _.cloneDeep(this.value.default_value);
        },

        onClickDelete()
        {
            this.$rc.confirm({
                'title': 'Delete this property',
                'body': 'Delete the '+this.value.name+' property?<br/><br/>This can not be undone.',
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doDelete();
                },
            });
        },

        doDelete()
        {
            this.dialog = false;
            this.$emit('modify', {
                'op': 'delete',
                'property_name': this.value.name,
            });
        },

        onClickFonts()
        {
            this.$router.push({
                'name': 'settings-organization-fonts',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },
    },

    computed: {
        default_value() 
        {
            if ( this.value == null || this.value.default_value == null )
                return null;

            return this.value.default_value.raw_value;
        },

        has_default_value()
        {
            return this.value != null && this.value.default_value != null && this.value.default_value.raw_value != null;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>